import api from '@pray/shared/utils/api';

export type SuperFunnelImportRunStatus = 'committed' | 'partial' | 'failed';

export type SuperFunnelImportRun = {
  id: string;
  file_kind: string;
  file_name: string | null;
  file_size_bytes: number | null;
  row_count: number;
  applied: {
    added: number;
    changed: number;
    unchanged: number;
    skipped: number;
  };
  audit_count: number;
  errors_count: number;
  status: SuperFunnelImportRunStatus;
  actor_user_id: number | null;
  reason: string | null;
  created_at: string;
};

export type GetImportRunsParams = {
  limit?: number;
  offset?: number;
  /**
   * 'me' restricts to runs the calling actor performed.
   * 'all' (default) returns all visible runs.
   */
  scope?: 'me' | 'all';
};

export type GetImportRunsResponse = {
  responded_at: string;
  object: 'list';
  data: SuperFunnelImportRun[];
  data_count: number;
  last_item_identifier: number | null;
  total: number;
  limit: number;
  offset: number;
};

export const getImportRuns = async ({
  limit,
  offset,
  scope,
}: GetImportRunsParams = {}): Promise<GetImportRunsResponse> => {
  const params: Record<string, string | number> = {};
  if (limit !== undefined) params.limit = limit;
  if (offset !== undefined) params.offset = offset;
  if (scope !== undefined) params.scope = scope;

  const url = '/web/studio/superfunnel/import/runs';
  const response = await api.executeGetRequest(url, params);

  return response.data as GetImportRunsResponse;
};
